module.exports = __webpack_public_path__ + "static/media/01.a86b6321.svg";